import { c as _c } from "react/compiler-runtime";
import { isSeatSoldOut, NO_FREE_SEAT_REASON } from "@components/table/members/assign-seats/assign-seats-utils";
import { Text } from "@flat-ui";
/**
 * Returns what checking or unchecking the seat does to the seats of the workspace, that the member
 * holds it already, or that none is left to give. Nothing for a seat the member does not hold and
 * does not get.
 */
function getSeatUsage(option, isChecked, seatsAvailable, seatsUsed) {
  if (option.isHeld) {
    return isChecked ? "Assigned" : "Frees 1 seat";
  }
  if (isSeatSoldOut(option)) {
    return NO_FREE_SEAT_REASON;
  }

  // Nothing can be told about the seats the change uses while the free ones are not known
  if (!isChecked || seatsAvailable === undefined) {
    return null;
  }
  return <>
      Uses <var>{seatsUsed}</var> of <var>{seatsAvailable}</var> remaining{" "}
      {seatsAvailable === 1 ? "seat" : "seats"}
    </>;
}

/**
 * Plain text in the corner of a seat card that tells whether the member holds the seat, how many
 * seats of the workspace checking or unchecking it uses or frees, or that none is left.
 */
export function SeatUsageText(t0) {
  const $ = _c(8);
  const {
    option,
    isChecked,
    seatsAvailable,
    seatsUsed: t1
  } = t0;
  const seatsUsed = t1 === undefined ? 1 : t1;
  let t2;
  if ($[0] !== isChecked || $[1] !== option || $[2] !== seatsAvailable || $[3] !== seatsUsed) {
    t2 = getSeatUsage(option, isChecked, seatsAvailable, seatsUsed);
    $[0] = isChecked;
    $[1] = option;
    $[2] = seatsAvailable;
    $[3] = seatsUsed;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const usage = t2;
  if (!usage) {
    return null;
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      color: "text.secondary",
      flexShrink: 0,
      whiteSpace: "nowrap"
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== usage) {
    t4 = <Text variant="bodyS" component="span" sx={t3}>{usage}</Text>;
    $[6] = usage;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}